import { lazy } from "react";

const PoliceIndex = lazy(() => import("src/views/arkadu/police/PoliceIndex"));
const PoliceFineDetail = lazy(
  () => import("src/views/arkadu/police/PoliceFineDetail"),
);

const police_routes = [
  {
    path: "/:customerName/police/",
    component: PoliceIndex,
  },
  {
    path: "/:customerName/police/fines/:fineId",
    component: PoliceFineDetail,
  },
];

export default police_routes;
